export function getInitials( name, isLastName ) {

    if ( !name ) {
        return '';
    }

    if ( isLastName ) {
        return name ? name[ 0 ] + name.slice( -1 ) : '';
    } else {
        return name ? name[ 0 ] : '';
    }
}
